import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

function BookingSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [bookingDetails, setBookingDetails] = useState(null);

  useEffect(() => {
    if (sessionId) {
      // In a real app, you'd fetch booking details from your backend
      // For now, we'll simulate success
      setTimeout(() => {
        setBookingDetails({
          workshopTitle: 'Southwest Colorado Fall Photography Workshop',
          participantName: 'John Doe',
          totalAmount: 2950,
          bookingId: 'BK-' + Date.now()
        });
        setLoading(false);
      }, 1000);
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-klorah-dark flex items-center justify-center">
        <div className="text-white">Processing your booking...</div>
      </div>
    );
  }

  if (!sessionId || !bookingDetails) {
    return (
      <div className="min-h-screen bg-klorah-dark flex items-center justify-center">
        <div className="max-w-md w-full text-center">
          <div className="glass-panel p-8">
            <div className="text-red-400 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-white mb-4">
              BOOKING NOT FOUND
            </h1>
            <p className="text-klorah-text mb-6">
              We couldn't find your booking details. Please contact support if you believe this is an error.
            </p>
            <Link
              to="/"
              className="klorah-button inline-block"
            >
              BACK TO WORKSHOPS
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-klorah-dark flex items-center justify-center py-8">
      <div className="max-w-2xl w-full mx-auto px-8">
        <div className="glass-panel p-8 text-center">
          {/* Success Icon */}
          <div className="text-green-600 mb-6">
            <svg className="w-20 h-20 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Booking Confirmed!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Thank you for your booking. You'll receive a confirmation email shortly with all the details.
          </p>

          {/* Booking Details */}
          <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Booking Details</h2>
            
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Workshop:</span>
                <span className="text-gray-900 font-medium">{bookingDetails.workshopTitle}</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-600">Participant:</span>
                <span className="text-gray-900 font-medium">{bookingDetails.participantName}</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-600">Total Paid:</span>
                <span className="text-gray-900 font-medium">${bookingDetails.totalAmount.toLocaleString()}</span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-600">Booking ID:</span>
                <span className="text-gray-900 font-medium font-mono">{bookingDetails.bookingId}</span>
              </div>
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">What's Next?</h3>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                Check your email for a detailed confirmation with calendar invite
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                Add the workshop dates to your calendar
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                We'll send you a detailed gear list and preparation guide 30 days before the workshop
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">•</span>
                Contact us at support@klorah.app if you have any questions
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link
              to="/"
              className="block w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 border border-blue-600"
            >
              Browse More Workshops
            </Link>
            
            <button
              onClick={() => window.print()}
              className="block w-full border border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50"
            >
              Print Confirmation
            </button>
          </div>

          {/* Support Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Need help? Contact us at{' '}
              <a href="mailto:support@klorah.app" className="text-blue-600 hover:text-blue-700">
                support@klorah.app
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingSuccess; 